import i18n from '@/locales/i18n'
import { ADMIN_PRODUCTS_ROUTES } from '@/router/routes'
import type { RouteType } from '@rfc/rfc-components-library/types'

export const ADMIN_PRODUCTS_LIST_ROUTE_NAME = 'adminProductsList'
export const ADMIN_PRODUCTS_DETAIL_ROUTE_NAME = 'adminProductsDetail'

const routes: RouteType[] = [
    {
        path: ADMIN_PRODUCTS_ROUTES.baseUrl,
        name: ADMIN_PRODUCTS_LIST_ROUTE_NAME,
        component: () => import('@/views/AdminView/AdminProductsView/AdminProductsView.vue'),
        meta: {
            title: i18n.global.t('menu.adminProducts'),
            authRequired: true
        }
    },
    {
        path: ADMIN_PRODUCTS_ROUTES.detailUrl,
        name: ADMIN_PRODUCTS_DETAIL_ROUTE_NAME,
        component: () => import('@/views/ProductsView/ProductDetailView.vue'),
        meta: {
            title: i18n.global.t('menu.adminProducts'),
            authRequired: true
        }
    }
]

export default routes
